import { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { MdOutlineModeEdit } from "react-icons/md";
import { TiArrowSortedDown } from "react-icons/ti";
import { Divider } from "@mui/material";
import ConfigurationModal from "../Modal/ConfigurationModal";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { create_email, get_email } from "../Redux/Action/EmailAction";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import useTitle from "../Hooks/useTitle";

// const QuillEditor = ({ value, onChange }) => {
//   const quillModules = useMemo(
//     () => ({
//       toolbar: [
//         ["bold", "italic"],
//         [{ align: [] }],
//         [{ list: "ordered" }, { list: "bullet" }],
//       ],
//     }),
//     []
//   );

//   return (
//     <ReactQuill
//       theme="snow"
//       value={value}
//       onChange={onChange}
//       modules={quillModules}
//     />
//   );
// };

const Configuration = () => {
  useTitle('Configuration');
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("configuration");

  const [displayModal, setDisplayModal] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const { email, loading } = useSelector((state) => state.Email);

  const [input, setInput] = useState({
    email_type_id: "",
    subject: "",
    message: "",
    regards: "",
  });

  useEffect(() => {
    dispatch(get_email());
  }, [dispatch]);

  const handleAccordionChange = (index, iteam) => {
    if (editingIndex !== index) {
      setInput({
        email_type_id: iteam.email_type_id,
        subject: iteam.email_configs?.subject || "",
        message: iteam.email_configs?.message || "",
        regards: iteam.email_configs?.regards || "",
      });
    }

    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleEdit = (event, iteam, index) => {
    event.stopPropagation();
    if (editingIndex === index) {
      setEditingIndex(null);
    } else {
      setEditingIndex(index);
      setActiveIndex(index);
      setInput({
        email_type_id: iteam.email_type_id,
        subject: iteam.email_configs?.subject || "",
        message: iteam.email_configs?.message || "",
        regards: iteam.email_configs?.regards || "",
      });
    }
  };

  const handleCancel = () => {
    setEditingIndex(null);
    setInput({
      email_type_id: "",
      subject: "",
      message: "",
      regards: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!input.subject || !input.message || !input.regards) {
      toast.error("Please fill all the fields!");
      return;
    }

    dispatch(
      create_email(
        input.email_type_id,
        input.subject,
        input.message,
        input.regards
      )
    )
      .then(() => {
        dispatch(get_email()); // Refresh email config after saving
      })
      .catch((error) => {
        console.error("Error while posting email config:", error);
      });

    setEditingIndex(null); // Reset to no edit mode
  };

  return (
    <>
      <div className="grid gap-6 p-8 py-6 mt-[76px] sm:ml-[300px] overflow-y-auto">
        <div className="items-center z-[1] ">
          <span className="font-[600] text-[26px]">{t("page_header")}</span>
        </div>
        {loading ? (
          <Box sx={{ alignItems: "center" }}>
            {[1, 2, 3, 4].map((items, i) => (
              <Box sx={{ width: "100%" }} key={i}>
                <Skeleton
                  width="100%"
                  height="100px"
                  sx={{ borderRadius: "20px" }}
                />
              </Box>
            ))}
          </Box>
        ) : (
          <form
            method="POST"
            action=""
            onSubmit={handleSubmit}
            className="rounded-2xl text-center flex flex-col grid gap-7"
          >
            {email &&
              email.data &&
              email.data.length > 0 &&
              email.data.map((iteam, i) => (
                <div key={i}>
                  <Accordion
                    expanded={activeIndex === i}
                    onChange={() => handleAccordionChange(i, iteam)}
                    sx={{
                      padding: "5px 0px",
                      "&.MuiPaper-root": {
                        borderRadius: "20px",
                        border: "none",
                        boxShadow: "none",
                      },
                    }}
                  >
                    <AccordionSummary
                      sx={{ fontSize: "18px" }}
                      expandIcon={<TiArrowSortedDown fill="black" />}
                      aria-controls={`panel${i}-content`}
                      id={`panel${i}-header`}
                    >
                      <Typography
                        component="span"
                        fontSize={"18px"}
                        fontWeight={500}
                        className="flex items-center w-full pl-2"
                      >
                        {i18n.language === "fr"
                          ? iteam.email_type_fr
                          : iteam.email_type}
                      </Typography>
                      <span
                        className="flex flex-end items-center pr-2"
                        onClick={(e) => handleEdit(e, iteam, i)}
                      >
                        <MdOutlineModeEdit size={22} fill="#3686FF" />
                      </span>
                    </AccordionSummary>
                    <Divider sx={{ marginBottom: "5px" }} />
                    <AccordionDetails className="text-left">
                      <div className="div grid gap-5">
                        <div className="grid gap-2">
                          <p className="text-[15px] text-[#6E737B]">
                            {t("accordion_subject_title")}
                          </p>
                          {editingIndex === i ? (
                            <textarea
                              id="subject"
                              name="subject"
                              rows="3"
                              value={input.subject}
                              onChange={(e) =>
                                setInput({ ...input, subject: e.target.value })
                              }
                              className="border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[15px] w-full text-[#000000] font-[500]"
                            ></textarea>
                          ) : iteam?.email_configs?.subject ? (
                            <p className="text-[15px] text-[#000000] font-[500]">
                              {iteam?.email_configs?.subject}
                            </p>
                          ) : (
                            <textarea
                              id="subject"
                              name="subject"
                              rows="3"
                              value={input.subject}
                              onChange={(e) =>
                                setInput({ ...input, subject: e.target.value })
                              }
                              className="border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[15px] w-full text-[#000000] font-[500]"
                            ></textarea>
                          )}
                        </div>
                        <div className="div grid gap-2">
                          <p className="text-[15px] text-[#6E737B]">
                            {t("accordion_description_title")}
                          </p>
                          {editingIndex === i ? (
                            <textarea
                              id="message"
                              name="message"
                              rows="7"
                              value={input.message}
                              onChange={(e) =>
                                setInput({ ...input, message: e.target.value })
                              }
                              className="border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[15px] w-full text-[#000000] font-[500]"
                            ></textarea>
                          ) : iteam?.email_configs?.message ? (
                            <pre className="text-[15px] text-[#000000] font-[500] text-wrap">
                              {iteam?.email_configs?.message}
                            </pre>
                          ) : (
                            <textarea
                              id="message"
                              name="message"
                              rows="7"
                              value={input.message}
                              onChange={(e) =>
                                setInput({ ...input, message: e.target.value })
                              }
                              className="border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[15px] w-full text-[#000000] font-[500]"
                            ></textarea>
                          )}
                        </div>
                        <div className="grid gap-2">
                          <p className="text-[15px] text-[#6E737B]">
                            {t("accordion_bestregard_title")}
                          </p>
                          {editingIndex === i ? (
                            <textarea
                              id="regards"
                              name="regards"
                              rows="1"
                              value={input.regards}
                              onChange={(e) =>
                                setInput({ ...input, regards: e.target.value })
                              }
                              className="border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[15px] w-full text-[#000000] font-[500]"
                            ></textarea>
                          ) : iteam?.email_configs?.regards ? (
                            <p className="text-[15px] text-[#000000] font-[500]">
                              {iteam?.email_configs?.regards}
                            </p>
                          ) : (
                            <textarea
                              id="regards"
                              name="regards"
                              rows="1"
                              value={input.regards}
                              onChange={(e) =>
                                setInput({ ...input, regards: e.target.value })
                              }
                              className="border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[15px] w-full text-[#000000] font-[500]"
                            ></textarea>
                          )}
                        </div>
                      </div>
                    </AccordionDetails>
                    {editingIndex === i || !iteam?.email_configs?.regards ? (
                      <div className="div">
                        <Divider sx={{ marginTop: 3 }} />
                        <div className="p-6 flex justify-end gap-3">
                          <button
                            className="text-[#3686FF] rounded-lg py-[12px] text-[14px] w-full max-w-40"
                            style={{ border: "1px solid #3686FF" }}
                            onClick={handleCancel}
                          >
                            {t("accordian_btn_cancel")}
                          </button>
                          <button
                            className="bg-[#3686FF] text-white rounded-lg py-[12px] text-[14px] w-full max-w-40"
                            onClick={handleSubmit}
                          >
                            {t("accordian_btn_save")}
                          </button>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </Accordion>
                </div>
              ))}
          </form>
        )}
      </div>
      <ConfigurationModal
        displayModal={displayModal}
        setDisplayModal={setDisplayModal}
      />
    </>
  );
};

export default Configuration;
